import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsApi } from '../lib/api';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) return;
    
    // Track page view
    const trackView = async () => {
      try {
        await analyticsApi.track(
          location.pathname,
          document.referrer || null
        );
      } catch (error) {
        // Silently fail - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackView();
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
